
// import React, { useState, useEffect } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import axios from 'axios';
// import {
//   Box,
//   Button,
//   Spinner,
//   Table,
//   Tbody,
//   Td,
//   Th,
//   Thead,
//   Tr,
//   Select,
//   Alert,
//   AlertIcon,
//   useToast,
// } from '@chakra-ui/react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import AdminNotifications from './AdminNotifications';
// import Api from '../../api/ApiUrl';

// const fetchBookings = async ({ queryKey }) => {
//   const [_, page, limit, status, billingmethod, sort] = queryKey;

//   const { data } = await axios.get(`${Api}/api/v1/payfiles/bookings`, {
//     params: { page, limit, status, billingmethod, sort },
//   });
//   return data;
// };

// const BookingList = () => {
//   const queryClient = useQueryClient();
//   const toast = useToast();
//   const history = useNavigate();
//   const location = useLocation();

//   const queryParams = new URLSearchParams(location.search);
//   const pageParam = parseInt(queryParams.get('page') || '1', 10);
//   const limitParam = parseInt(queryParams.get('limit') || '10', 10);
//   const statusParam = queryParams.get('status') || '';
//   const billingmethodParam = queryParams.get('billingmethod') || '';
//   const sortParam = queryParams.get('sort') || 'createdAt';

//   const [page, setPage] = useState(pageParam);
//   const [limit, setLimit] = useState(limitParam);
//   const [status, setStatus] = useState(statusParam);
//   const [billingmethod, setBillingmethod] = useState(billingmethodParam);
//   const [sort, setSort] = useState(sortParam);

//   useEffect(() => {
//     const queryParams = new URLSearchParams();
//     queryParams.set('page', page);
//     queryParams.set('limit', limit);
//     if (status) queryParams.set('status', status);
//     if (billingmethod) queryParams.set('billingmethod', billingmethod);
//     if (sort) queryParams.set('sort', sort);
//     history({ search: queryParams.toString() });
//   }, [page, limit, status, billingmethod, sort, history]);

//   const { data, isLoading, isError, error } = useQuery(
//     ['bookings', page, limit, status, billingmethod, sort],
//     fetchBookings
//   );

//   const approveMutation = useMutation(
//     (id) => axios.patch(`${Api}/payfiles/bookings/${id}/approve`),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries('bookings');
//         toast({ title: 'Booking approved.', status: 'success' });
//       },
//     }
//   );

//   const rejectMutation = useMutation(
//     (id) => axios.patch(`${Api}/payfiles/bookings/${id}/reject`),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries('bookings');
//         toast({ title: 'Booking rejected.', status: 'error' });
//       },
//     }
//   );

//   const markAsSeenMutation = useMutation(
//     (id) => axios.patch(`${Api}/payfiles/bookings/${id}/seen`),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries('bookings');
//         toast({ title: 'Booking marked as seen.', status: 'info' });
//       },
//     }
//   );

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (isError) {
//     return (
//       <Alert status="error">
//         <AlertIcon />
//         {error.message}
//       </Alert>
//     );
//   }

//   return (
//     <Box>
//       <AdminNotifications />
//       <Box mb="4">
//         <Select value={status} onChange={(e) => setStatus(e.target.value)} placeholder="Filter by status">
//           <option value="approved">Approved</option>
//           <option value="pending">Pending</option>
//           <option value="rejected">Rejected</option>
//         </Select>
//         <Select value={billingmethod} onChange={(e) => setBillingmethod(e.target.value)} placeholder="Filter by billing method">
//           <option value="wallet">Wallet</option>
//           <option value="mobile">Mobile</option>
//           <option value="bank">Bank</option>
//           <option value="instapay">Instapay</option>
//         </Select>
//         <Select value={sort} onChange={(e) => setSort(e.target.value)} placeholder="Sort by">
//           <option value="createdAt">Date</option>
//           <option value="amount">Amount</option>
//         </Select>
//       </Box>
//       <Table>
//         <Thead>
//           <Tr>
//             <Th>User</Th>
//             <Th>Item</Th>
//             <Th>Amount</Th>
//             <Th>Status</Th>
//             <Th>Billing Method</Th>
//             <Th>Date</Th>
//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {data.data.data.map((booking) => (
//             <Tr key={booking._id}>
//               <Td>{booking.userId.name}</Td>
//               <Td>{booking.item.name}</Td>
//               <Td>{booking.amount}</Td>
//               <Td>{booking.status}</Td>
//               <Td>{booking.billingmethod}</Td>
//               <Td>{new Date(booking.createdAt).toLocaleDateString()}</Td>
//               <Td>
//                 <Button
//                   colorScheme="green"
//                   onClick={() => approveMutation.mutate(booking._id)}
//                   isDisabled={booking.status !== 'pending'}
//                 >
//                   Approve
//                 </Button>
//                 <Button
//                   colorScheme="red"
//                   onClick={() => rejectMutation.mutate(booking._id)}
//                   isDisabled={booking.status !== 'pending'}
//                 >
//                   Reject
//                 </Button>
//                 <Button
//                   colorScheme="blue"
//                   onClick={() => markAsSeenMutation.mutate(booking._id)}
//                   isDisabled={booking.seenByadmin}
//                 >
//                   Mark as Seen
//                 </Button>
//                 <Link to={{ pathname: `/dashboard/admin/filesbooking/${booking._id}`, state: { booking } }}>
//                   <Button colorScheme="blue">View</Button>
//                 </Link>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>
//       <Box mt="4">
//         <Button onClick={() => setPage(page - 1)} isDisabled={page === 1}>
//           Previous
//         </Button>
//         <Button onClick={() => setPage(page + 1)} isDisabled={data.data.data.length < limit}>
//           Next
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default BookingList;


// import React, { useState } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import axios from 'axios';
// import {
//   Box,
//   Button,
//   Spinner,
//   Table,
//   Tbody,
//   Td,
//   Th,
//   Thead,
//   Tr,
//   Select,
//   Alert,
//   AlertIcon,
//   useToast,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
//   ModalFooter,
//   Text,
//   Image,
//   VStack,
// } from '@chakra-ui/react';
// import Api from '../../api/ApiUrl';
// import AdminNotifications from './AdminNotifications';

// const fetchBookings = async ({ queryKey }) => {
//   // const [_, page, limit, status, billingmethod, sort] = queryKey;
//   const [_, page, status, billingmethod, sort] = queryKey;


//   const params = { page };
//   if (status) params.status = status;
//   if (billingmethod) params.billingmethod = billingmethod;
//   if (sort) params.sort = sort;

//   const { data } = await axios.get(`${Api}/api/v1/payfiles/bookings`, { params });
//   return data;
// };
// // console.log(`${Api}/${selectedBooking.billImage.path}`)
// const BookingList = () => {
//   const queryClient = useQueryClient();
//   const toast = useToast();
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const { data, isLoading, isError, error } = useQuery(
//     // ['bookings', 1, 100, '', '', 'createdAt'],
//     ['bookings', 1, '', '', 'createdAt'],

//     fetchBookings
//   );

//   const approveMutation = useMutation(
//     (id) => axios.patch(`${Api}/api/v1/payfiles/bookings/${id}/approve`),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries('bookings');
//         toast({ title: 'Booking approved.', status: 'success' });
//       },
//     }
//   );

//   const rejectMutation = useMutation(
//     (id) => axios.patch(`${Api}/api/v1/payfiles/bookings/${id}/reject`),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries('bookings');
//         toast({ title: 'Booking rejected.', status: 'error' });
//       },
//     }
//   );

//   const handleView = (booking) => {
//     setSelectedBooking(booking);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedBooking(null);
//   };

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (isError) {
//     return (
//       <Alert status="error">
//         <AlertIcon />
//         {error.message}
//       </Alert>
//     );
//   }

//   return (
//     <Box>
//       <AdminNotifications />
//       <Table>
//         <Thead>
//           <Tr>
//             <Th>User</Th>
//             <Th>Phone Number</Th>
//             <Th>Item</Th>
//             <Th>Amount</Th>
//             <Th>Status</Th>
//             <Th>Billing Method</Th>
//             <Th>Date</Th>
//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {data?.data?.data?.map((booking) => (
//             <Tr key={booking._id}>
//               <Td>{booking?.userId?.name}</Td>
//               <Td>{booking?.userId?.phoneNumber}</Td>
//               <Td>{booking?.item?.name}</Td>
//               <Td>{booking?.amount}</Td>
//               <Td>{booking?.status}</Td>
//               <Td>{booking?.billingmethod}</Td>
//               <Td>{new Date(booking?.createdAt).toLocaleDateString()}</Td>
//               <Td>
//                 <Button
//                   colorScheme="green"
//                   onClick={() => approveMutation.mutate(booking._id)}
//                   isDisabled={booking.status !== 'pending'}
//                 >
//                   Approve
//                 </Button>
//                 <Button
//                   colorScheme="red"
//                   onClick={() => rejectMutation.mutate(booking._id)}
//                   isDisabled={booking.status !== 'pending'}
//                 >
//                   Reject
//                 </Button>
//                 <Button colorScheme="blue" onClick={() => handleView(booking)}>
//                   View
//                 </Button>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>

//       {selectedBooking && (
//         <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
//           <ModalOverlay />
//           <ModalContent>
//             <ModalHeader>Booking Details</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//               <VStack align="start">
//                 <Text><strong>User Name:</strong> {selectedBooking.userId.name}</Text>
//                 <Text><strong>Phone Number:</strong> {selectedBooking.userId.phoneNumber}</Text>
//                 <Text><strong>Item Name:</strong> {selectedBooking?.item?.name}</Text>
//                 <Text><strong>Amount:</strong> {selectedBooking.amount}</Text>
//                 <Text><strong>Status:</strong> {selectedBooking.status}</Text>
//                 <Text><strong>Billing Method:</strong> {selectedBooking.billingmethod}</Text>
//                 <Text><strong>Date:</strong> {new Date(selectedBooking.createdAt).toLocaleDateString()}</Text>
//                 {selectedBooking.billImage && (
//                   <Box mt={4}>
//                     <Text><strong>Bill Image:</strong></Text>
//                     <Image src={`${Api}/${selectedBooking.billImage.path}`} alt="Bill Image" boxSize="200px" />
//                   </Box>
//                 )}
//               </VStack>
//             </ModalBody>
//             <ModalFooter>
//               <Button colorScheme="teal" onClick={handleCloseModal}>
//                 Close
//               </Button>
//             </ModalFooter>
//           </ModalContent>
//         </Modal>
//       )}
//     </Box>
//   );
// };

// export default BookingList;


// import React, { useState, useMemo } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import axios from 'axios';
// import {
//   Box,
//   Button,
//   Spinner,
//   Table,
//   Tbody,
//   Td,
//   Th,
//   Thead,
//   Tr,
//   Input,
//   Alert,
//   AlertIcon,
//   useToast,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
//   ModalFooter,
//   Text,
//   Image,
//   VStack,
// } from '@chakra-ui/react';
// import Api from '../../api/ApiUrl';
// import AdminNotifications from './AdminNotifications';

// const fetchBookings = async ({ queryKey }) => {
//   const [_, page, limit, status, billingmethod, sort] = queryKey;

//   const params = { page, limit };
//   if (status) params.status = status;
//   if (billingmethod) params.billingmethod = billingmethod;
//   if (sort) params.sort = sort;

//   const { data } = await axios.get(`${Api}/api/v1/payfiles/bookings`, { params });
//   return data;
// };

// const BookingList = () => {
//   const queryClient = useQueryClient();
//   const toast = useToast();
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [phoneNumber, setPhoneNumber] = useState('');  // State for phone number search
//   const [page, setPage] = useState(1);                 // State for pagination
//   const limit = 20;                                    // Fixed limit for pagination

//   // Fetch data from the server (all bookings)
//   const { data, isLoading, isError, error, refetch } = useQuery(
//     ['bookings', page, limit, '', '', 'createdAt'],  // Remove phoneNumber from queryKey
//     fetchBookings
//   );

//   const approveMutation = useMutation(
//     (id) => axios.patch(`${Api}/api/v1/payfiles/bookings/${id}/approve`),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries('bookings');
//         toast({ title: 'Booking approved.', status: 'success' });
//       },
//     }
//   );

//   const rejectMutation = useMutation(
//     (id) => axios.patch(`${Api}/api/v1/payfiles/bookings/${id}/reject`),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries('bookings');
//         toast({ title: 'Booking rejected.', status: 'error' });
//       },
//     }
//   );

//   const handleView = (booking) => {
//     setSelectedBooking(booking);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedBooking(null);
//   };

//   const handleSearchChange = (e) => {
//     setPhoneNumber(e.target.value);
//   };

//   // Filter bookings by phone number
//   const filteredBookings = useMemo(() => {
//     if (!phoneNumber) return data?.data?.data || [];
//     return data?.data?.data.filter(booking => 
//       booking?.userId?.phoneNumber?.includes(phoneNumber)
//     );
//   }, [phoneNumber, data]);

//   // Paginate the filtered results
//   const paginatedBookings = useMemo(() => {
//     const startIndex = (page - 1) * limit;
//     return filteredBookings.slice(startIndex, startIndex + limit);
//   }, [filteredBookings, page, limit]);

//   const handleNextPage = () => {
//     setPage((prevPage) => prevPage + 1);  // Go to next page
//   };

//   const handlePreviousPage = () => {
//     if (page > 1) {
//       setPage((prevPage) => prevPage - 1);  // Go to previous page
//     }
//   };

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (isError) {
//     return (
//       <Alert status="error">
//         <AlertIcon />
//         {error.message}
//       </Alert>
//     );
//   }

//   return (
//     <Box>
//       <AdminNotifications />

//       {/* Search input for phone number */}
//       <Box mb={4}>
//         <Input
//           placeholder="Search by phone number"
//           value={phoneNumber}
//           onChange={handleSearchChange}
//           width="300px"
//           mr={2}
//         />
//       </Box>

//       <Table>
//         <Thead>
//           <Tr>
//             <Th>User</Th>
//             <Th>Phone Number</Th>
//             <Th>Item</Th>
//             <Th>Amount</Th>
//             <Th>Status</Th>
//             <Th>Billing Method</Th>
//             <Th>Date</Th>
//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {paginatedBookings.map((booking) => (
//             <Tr key={booking._id}>
//               <Td>{booking?.userId?.name}</Td>
//               <Td>{booking?.userId?.phoneNumber}</Td>
//               <Td>{booking?.item?.name}</Td>
//               <Td>{booking?.amount}</Td>
//               <Td>{booking?.status}</Td>
//               <Td>{booking?.billingmethod}</Td>
//               <Td>{new Date(booking?.createdAt).toLocaleDateString()}</Td>
//               <Td>
//                 <Button
//                   colorScheme="green"
//                   onClick={() => approveMutation.mutate(booking._id)}
//                   isDisabled={booking.status !== 'pending'}
//                 >
//                   Approve
//                 </Button>
//                 <Button
//                   colorScheme="red"
//                   onClick={() => rejectMutation.mutate(booking._id)}
//                   isDisabled={booking.status !== 'pending'}
//                 >
//                   Reject
//                 </Button>
//                 <Button colorScheme="blue" onClick={() => handleView(booking)}>
//                   View
//                 </Button>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>

//       {/* Pagination Controls */}
//       <Box mt={4} display="flex" justifyContent="space-between">
//         <Button onClick={handlePreviousPage} isDisabled={page === 1}>
//           Previous
//         </Button>
//         <Text>Page {page}</Text>
//         <Button onClick={handleNextPage} isDisabled={paginatedBookings.length < limit}>
//           Next
//         </Button>
//       </Box>

//       {selectedBooking && (
//         <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
//           <ModalOverlay />
//           <ModalContent>
//             <ModalHeader>Booking Details</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//               <VStack align="start">
//                 <Text><strong>User Name:</strong> {selectedBooking.userId.name}</Text>
//                 <Text><strong>Phone Number:</strong> {selectedBooking.userId.phoneNumber}</Text>
//                 <Text><strong>Item Name:</strong> {selectedBooking?.item?.name}</Text>
//                 <Text><strong>Amount:</strong> {selectedBooking.amount}</Text>
//                 <Text><strong>Status:</strong> {selectedBooking.status}</Text>
//                 <Text><strong>Billing Method:</strong> {selectedBooking.billingmethod}</Text>
//                 <Text><strong>Date:</strong> {new Date(selectedBooking.createdAt).toLocaleDateString()}</Text>
//                 {selectedBooking.billImage && (
//                   <Box mt={4}>
//                     <Text><strong>Bill Image:</strong></Text>
//                     <Image src={`${Api}/${selectedBooking.billImage.path}`} alt="Bill Image" boxSize="200px" />
//                   </Box>
//                 )}
//               </VStack>
//             </ModalBody>
//             <ModalFooter>
//               <Button colorScheme="teal" onClick={handleCloseModal}>
//                 Close
//               </Button>
//             </ModalFooter>
//           </ModalContent>
//         </Modal>
//       )}
//     </Box>
//   );
// };

// export default BookingList;


import React, { useState, useMemo } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import {
  Box,
  Button,
  Spinner,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Input,
  Select,
  Alert,
  AlertIcon,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Image,
  VStack,
} from '@chakra-ui/react';
import Api from '../../api/ApiUrl';
import AdminNotifications from './AdminNotifications';

const fetchBookings = async ({ queryKey }) => {
  const [_, page, limit, status, billingmethod, sort] = queryKey;
  const params = {  };
  if (status) params.status = status;
  if (billingmethod) params.billingmethod = billingmethod;
  if (sort) params.sort = sort;

  const { data } = await axios.get(`${Api}/api/v1/payfiles/bookings`, { params });
  return data;
};

const BookingList = () => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');  // State for phone number search
  const [statusFilter, setStatusFilter] = useState('');  // State for status filter
  const [billingMethodFilter, setBillingMethodFilter] = useState('');  // State for billing method filter
  const [page, setPage] = useState(1);  // State for pagination
  const limit = 1000;  // Fixed limit for pagination

  // Fetch data from the server (bookings)
  const { data, isLoading, isError, error, refetch } = useQuery(
    ['bookings', page, limit, statusFilter, billingMethodFilter, '-createdAt'], // Add filters to queryKey
    fetchBookings
  );

  const approveMutation = useMutation(
    (id) => axios.patch(`${Api}/api/v1/payfiles/bookings/${id}/approve`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('bookings');
        toast({ title: 'Booking approved.', status: 'success' });
      },
    }
  );

  const rejectMutation = useMutation(
    (id) => axios.patch(`${Api}/api/v1/payfiles/bookings/${id}/reject`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('bookings');
        toast({ title: 'Booking rejected.', status: 'error' });
      },
    }
  );

  const handleView = (booking) => {
    setSelectedBooking(booking);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBooking(null);
  };

  const handleSearchChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleBillingMethodChange = (e) => {
    setBillingMethodFilter(e.target.value);
  };

  // Filter bookings by phone number
  const filteredBookings = useMemo(() => {
    if (!phoneNumber) return data?.data?.data || [];
    return data?.data?.data.filter((booking) =>
      booking?.userId?.phoneNumber?.includes(phoneNumber)
    );
  }, [phoneNumber, data]);

  // Paginate the filtered results
  const paginatedBookings = useMemo(() => {
    const startIndex = (page - 1) * limit;
    return filteredBookings.slice(startIndex, startIndex + limit);
  }, [filteredBookings, page, limit]);

  const handleNextPage = () => {
    if (paginatedBookings.length >= limit) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage((prevPage) => prevPage - 1);
    }
  };

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return (
      <Alert status="error">
        <AlertIcon />
        {error.message}
      </Alert>
    );
  }

  return (
    <Box>
      <AdminNotifications />

      {/* Filter and Search Inputs */}
      <Box mb={4} display="flex" alignItems="center">
        <Input
          placeholder="Search by phone number"
          value={phoneNumber}
          onChange={handleSearchChange}
          width="300px"
          mr={4}
        />

        <Select placeholder="Filter by status" value={statusFilter} onChange={handleStatusChange} width="200px" mr={4}>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </Select>

        <Select
          placeholder="Filter by billing method"
          value={billingMethodFilter}
          onChange={handleBillingMethodChange}
          width="200px"
        >
         <option value="wallet">Wallet</option>
        <option value="mobile">Mobile</option>
          <option value="bank">Bank</option>
          <option value="instapay">Instapay</option>
        </Select>
      </Box>

      {/* Bookings Table */}
      <Table>
        <Thead>
          <Tr>
            <Th>User</Th>
            <Th>Phone Number</Th>
            <Th>Item</Th>
            <Th>Amount</Th>
            <Th>Status</Th>
            <Th>Billing Method</Th>
            <Th>Date</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {paginatedBookings.map((booking) => (
            <Tr key={booking._id}>
              <Td>{booking?.userId?.name}</Td>
              <Td>{booking?.userId?.phoneNumber}</Td>
              <Td>{booking?.item?.name}</Td>
              <Td>{booking?.amount}</Td>
              <Td>{booking?.status}</Td>
              <Td>{booking?.billingmethod}</Td>
              <Td>{new Date(booking?.createdAt).toLocaleDateString()}</Td>
              <Td>
                <Button
                  colorScheme="green"
                  onClick={() => approveMutation.mutate(booking._id)}
                  isDisabled={booking.status !== 'pending'}
                >
                  Approve
                </Button>
                <Button
                  colorScheme="red"
                  onClick={() => rejectMutation.mutate(booking._id)}
                  isDisabled={booking.status !== 'pending'}
                >
                  Reject
                </Button>
                <Button colorScheme="blue" onClick={() => handleView(booking)}>
                  View
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      {/* Pagination Controls */}
      <Box mt={4} display="flex" justifyContent="space-between">
        <Button onClick={handlePreviousPage} isDisabled={page === 1}>
          Previous
        </Button>
        <Text>Page {page}</Text>
        <Button onClick={handleNextPage} isDisabled={paginatedBookings.length < limit}>
          Next
        </Button>
      </Box>

      {/* Booking Details Modal */}
      {selectedBooking && (
        <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Booking Details</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack align="start">
                <Text><strong>User Name:</strong> {selectedBooking.userId.name}</Text>
                <Text><strong>Phone Number:</strong> {selectedBooking.userId.phoneNumber}</Text>
                <Text><strong>Item Name:</strong> {selectedBooking?.item?.name}</Text>
                <Text><strong>Amount:</strong> {selectedBooking.amount}</Text>
                <Text><strong>Status:</strong> {selectedBooking.status}</Text>
                <Text><strong>Billing Method:</strong> {selectedBooking.billingmethod}</Text>
                <Text><strong>Date:</strong> {new Date(selectedBooking.createdAt).toLocaleDateString()}</Text>
                {selectedBooking.billImage && (
                  <Box mt={4}>
                    <Text><strong>Bill Image:</strong></Text>
                    <Image src={`${Api}/${selectedBooking.billImage.path}`} alt="Bill Image" boxSize="200px" />
                  </Box>
                )}
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="teal" onClick={handleCloseModal}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default BookingList;
